import { http } from '@/plugins/http'
import { type AxiosResponse } from 'axios'

import type PaginatedResponse from '@/types/PaginatedResponse'
import type DataResponse from '@/types/DataResponse'
import type PrePrint from '@/types/PrePrint'
import type Section from '@/types/Section'

export interface StorePayload {
  items: {
    quantity: number
    batch_id: string
    section_id: string
    tag: string | null
  }[]
  event_id: string
  pos_id: string
  items_per_print: number
  type_name: string
}

export default class PrePrintService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<PrePrint>>> {
    return await http.get<PaginatedResponse<PrePrint>>(`/api/v1/office/pre-print?page=${page}&${filters}&per_page=${per_page}`)
  }

  async store(payload: StorePayload) {
    return await http.post<DataResponse<PrePrint>>(`/api/v1/office/pre-print`, payload)
  }

  async destroy(model: PrePrint) {
    return await http.delete(`/api/v1/office/pre-print/${model.id}`)
  }

  async sections(filters?: string) {
    const response = await http.get<Section[]>(`/api/v1/office/pre-print/sections?${filters ?? ''}`)
    return response.data
  }

  print(prePrintId: string) {
    window.open(`${import.meta.env.VITE_PRINTER_URL}/print?lote=${prePrintId}`, '_blank', 'width=1,height=1')
  }

  testPrinter() {
    window.open(`${import.meta.env.VITE_PRINTER_URL}/teste`, '_blank', 'width=280,height=100')
  }
}
